import React, { useEffect } from 'react';
import {
  Box,
  Text,
  Flex,
  Image,
  Divider,
  Heading,
  Grid,
  GridItem,
} from '@chakra-ui/react';
import Aos from 'aos';
import 'aos/dist/aos.css';
import './project.css';
import socialMedia from '../../assets/social-media.png'
import codeeditor from '../../assets/code_editor.png';
import healthKart from '../../assets/healthKart.png';
import sandesh from '../../assets/sandesh.png';
// import fireFox from '../../assets/fireFox.png';

const Projects = () => {
  const projects = [
    {
      id: 1,
      heading: 'SOCIAL  MEDIAL APPLICATION',
      description:
        'A Responsive social media site to post user feelings, connect with others and make friends',
      techs: [
        ['bx bxl-nodejs', '#0fa068'],
        ['bx bxl-mongodb', '#2dd690'],
        ['bx bxl-mui', '#131312'],
        ['bx bxl-react', '#84e3e5'],
      ],
      link: 'https://social-post-app-project.netlify.app/',
      github: 'https://github.com/amareshcoding/social-app-client',
      order: ['1', '2'],
      img: socialMedia, //need to change
    },
    {
      id: 2,
      heading: 'HEALTHKART.COM CLONE',
      description:
        'Healthkart is a online platform for Fitness Products, Vitamins & Supplements to by at most affordable price. Its an Group Project of 4',
      techs: [
        ['bx bxl-html5', '#f1a118'],
        ['bx bxl-css3', '#4e95e7'],
        ['bx bxl-javascript', '#f7df1a'],
      ],
      link: 'https://healthkart-clone-fullstack.netlify.app/',
      github: 'https://github.com/amareshcoding/healthKart.com_clone_2.0',
      order: ['2', '1'],
      img: healthKart, //need to change
    },
    {
      id: 3,
      heading: 'LIVE CODE EDITOR',
      description:
        'This App can use for live coding Interviews, Here both the Interviewer and the interviewee can code simultaneously on a real-time basis.',
      techs: [
        ['bx bxl-nodejs', '#0fa068'],
        ['bx bxl-mongodb', '#2dd690'],
        ['bx bxl-socket', '#131312'],
        ['bx bxl-react', '#84e3e5'],
      ],
      link: 'https://code-editor-6bjw.onrender.com/',
      github: 'https://github.com/amareshcoding/live_code_editor',
      order: ['1', '2'],
      img: codeeditor,
    },
    {
      id: 4,
      heading: 'SANDESH',
      description:
        'Sandesh is a live chat application, here you can search user, create groups and chat with friends.',
      techs: [
        ['bx bxl-nodejs', '#0fa068'],
        ['bx bxl-mongodb', '#2dd690'],
        ['bx bxl-socket', '#131312'],
        ['bx bxl-react', '#84e3e5'],
      ],
      link: 'https://sandesh-chat-app.netlify.app/',
      github: 'https://github.com/amareshcoding/sandesh',
      order: ['2', '1'],
      img: sandesh,
    },
  ];

  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  return (
    <section className="projects section" id="projects">
      <h2 className="section__title">Projects</h2>
      <span className="section__subtitle">The things I make</span>
      {projects.map((elem) => (
        <Flex
          key={elem.id}
          textAlign="center"
          w={'75%'}
          m={'auto'}
          justify={'space-between'}
          mb={20}
          gap={{ md: '4', sm: '4', base: '4' }}
          boxShadow="2xl"
          p={{ lg: '10', md: '8', sm: '4', base: '4' }}
          rounded="md"
          bg="white"
          flexDirection={{
            lg: 'row',
            md: 'column',
            sm: 'column',
            base: 'column',
          }}
        >
          <Box
            w={{ lg: '50%', md: '100%', sm: '100%', base: '100%' }}
            m={'auto'}
            order={elem.order[0]}
          >
            <div
              style={{
                width: '100%',
                margin: 'auto',
              }}
              data-aos="fade-up"
              data-aos-easing="ease-in"
            >
              <Box m={'auto'} w={{ md: '80%', sm: '90%', base: '90%' }}>
                <Heading
                  color={'var(--text-color)'}
                  fontWeight={'700'}
                  fontSize={'25px'}
                >
                  {elem.heading}
                </Heading>
                <Divider mt={'2'} />
                <Text mt={'3'}>{elem.description}</Text>
              </Box>
              <Grid
                mt={5}
                templateRows="repeat(2, 1fr)"
                templateColumns="repeat(2,1fr)"
                justifyContent={'center'}
                gap={3}
              >
                <GridItem rowSpan={1} colSpan={2}>
                  <Flex
                    alignItems={'center'}
                    wrap={'wrap'}
                    gap={3}
                    justifyContent={'center'}
                  >
                    <Text fontWeight={'700'}>Tech stack : </Text>
                    {elem.techs.map((tech) => (
                      <i
                        key={tech[0]}
                        className={tech[0]}
                        style={{ color: tech[1], fontSize: '40px' }}
                      ></i>
                    ))}
                  </Flex>
                </GridItem>

                <GridItem colSpan={2} rowSpan={1}>
                  <Flex gap={4} justifyContent={'center'}>
                    <a
                      href={elem.link}
                      className="button button--flex"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Live
                      <span className="button__icon">
                        <i
                          className="bx bx-link-external"
                          style={{ color: '#ffffff' }}
                        ></i>
                      </span>
                    </a>
                    <a
                      href={elem.github}
                      className="button button--flex"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Github
                      <span className="button__icon">
                        <i
                          className="bx bxl-github"
                          style={{ color: '#ffffff' }}
                        ></i>
                      </span>
                    </a>
                  </Flex>
                </GridItem>
              </Grid>
            </div>
          </Box>
          <Box
            w={{ lg: '50%', md: '80%', sm: '80%', base: '80%' }}
            m={'auto'}
            order={elem.order[1]}
          >
            <div
              style={{
                width: '100%',
                margin: 'auto',
              }}
              data-aos="fade-up"
              data-aos-easing="ease-in"
            >
              <Box m={'auto'} w={'full'}>
                <Image w={'100%'} m={'auto'} src={elem.img} alt="Dan Abramov" />
              </Box>
            </div>
          </Box>
        </Flex>
      ))}
    </section>
  );
};

export default Projects;
// ["bx bxl-html5", "#f1a118"],
//           ["bx bxl-css3", "#4e95e7"],
//           ["bx bxl-javascript", "#f7df1a"],
